// AgentVerse/common/schemas/collections/projects.js

import { z } from "zod";

const ProjectParticipantsSchema = z.object({
    contacts: z.array(z.string()).optional().default([]).describe("Directly added participant contact IDs."),
    tags: z.array(z.string()).optional().default([]).describe("Tags for including groups of contacts."),
}).optional().default({ contacts: [], tags: [] });

const ProjectSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    ownerId: z.string().describe("ID of the user who owns the project (creator)."),
    name: z.string().min(1, "Project name is required."),
    description: z.string().optional().nullable(),
    scope: z.enum(["private", "public", "shared"])
        .default("private")
        .describe("Scope of the project: private (owner only), public (all users), shared (specific users/groups)."),
    
    // --- ADD THIS LINE ---
    participants: ProjectParticipantsSchema,

    settings: z.object({
        defaultAgentName: z.string().optional().nullable().describe("Default agent to use for this project"),
    }).optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ProjectSchema;